import { plural } from '@cian/utils';

import { IOfferBuilding } from '../../types/offers';

export const getFloorCount = (building?: IOfferBuilding): string => {
  if (building && building.floorsCount) {
    return `${building.floorsCount} ${plural(building.floorsCount, ['этаж', 'этажа', 'этажей'])}`;
  }

  return '';
};

export const getFloorRange = (building?: IOfferBuilding, floorNumber?: number): string => {
  if (floorNumber && building && building.floorsCount) {
    return `${floorNumber}/${building.floorsCount} этаж`;
  }

  if (floorNumber) {
    return `${floorNumber} этаж`;
  }

  return '';
};
